import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	fieldNotFoundMessage: {
		id: 'issue-navigator.jql-builder.no-options-message.field-not-found-message',
		defaultMessage: "We couldn't find the field you are looking for.",
		description: 'The text displayed when search results for fields do not return matching results',
	},
});
